// Shared display-only transforms for astrologer star rating + review count.
// The underlying DB values are untouched — these are deterministic visual
// overlays so listing cards, detail pages, the landing rail, and any future
// surface ALL show the same number for the same astrologer.

export function displayedReviewsCount(astrologerId) {
  if (!astrologerId) return 5000;
  let hash = 0;
  for (let i = 0; i < astrologerId.length; i++) {
    hash = ((hash * 131) + astrologerId.charCodeAt(i)) | 0;
  }
  return 5000 + (Math.abs(hash) % 10001); // 5000..15000 inclusive
}

export function displayedRating(astrologerId) {
  if (!astrologerId) return "4.9";
  let hash = 0;
  for (let i = 0; i < astrologerId.length; i++) {
    hash = ((hash * 17) + astrologerId.charCodeAt(i)) | 0;
  }
  const choices = ["4.8", "4.9", "5.0"];
  return choices[Math.abs(hash) % choices.length];
}
